export const SURVEY_MENU_TYPE = {
    LIST: 'list',
    EDIT: 'edit',
    ADD: 'add',
    VOTE: 'vote'
};
